<div class="forbidden">
  <app-icon icon="app-illustration-error"></app-icon>
  <p educa-text variant="xl" weight="semibold" color="gray-500" i18n>Access forbidden</p>
  <p educa-text variant="sm" weight="normal" color="gray-500" i18n>
    It is not possible to access to the requested page.
  </p>
  <button educa-button variant="primary" (click)="goHomepage()" i18n>Go to homepage</button>
</div>
